import React from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { EASE, fadeUp } from "../../lib/motion";
import { useModal } from "../../lib/ModalContext";

export const FAQ = ({ content }) => {
    const items = content?.faq?.items || [];
    const [openIdx, setOpenIdx] = React.useState(0);
    const { open } = useModal();

    return (
        <section id="faq" className="relative py-6 md:py-20 bg-[#EFEFEA]" data-testid="faq-section">
            <div className="mx-auto max-w-[1240px] px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <motion.span {...fadeUp(0)} className="text-xs uppercase tracking-[0.24em] text-oth-ink3 font-body">{content?.faq?.eyebrow || "Frequently asked"}</motion.span>
                        <motion.h2 {...fadeUp(0.1)} className="mt-4 font-display font-semibold text-[40px] sm:text-[52px] md:text-[64px] leading-[1.02] tracking-[-0.035em]">
                            Quiet answers to the questions families ask.
                        </motion.h2>
                        <motion.button {...fadeUp(0.25)} onClick={() => open("contact")} className="btn-pill btn-pill-dark mt-10 text-sm" data-testid="faq-contact-cta">
                            Still curious? Contact us
                        </motion.button>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="divide-y divide-oth-line/70" data-testid="faq-section-list">
                            {items.map((it, i) => {
                                const isOpen = openIdx === i;
                                return (
                                    <motion.button
                                        key={`faq-${it.q || i}`}
                                        {...fadeUp(0.05 * i)}
                                        onClick={() => setOpenIdx(isOpen ? -1 : i)}
                                        className="w-full text-left py-6 md:py-7 group"
                                        data-testid={`faq-section-item-${i}`}
                                    >
                                        <div className="flex items-center justify-between gap-6">
                                            <span className="font-display text-xl md:text-2xl font-semibold tracking-tight">{it.q}</span>
                                            <span className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 transition-colors duration-700 ${isOpen ? "bg-[#0B3B60] text-white" : "bg-white text-oth-ink"}`}>
                                                <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.6, ease: EASE }}>
                                                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                                                </motion.span>
                                            </span>
                                        </div>
                                        <motion.div
                                            initial={false}
                                            animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0, marginTop: isOpen ? 14 : 0 }}
                                            transition={{ duration: 0.8, ease: EASE }}
                                            className="overflow-hidden"
                                        >
                                            <p className="font-body text-base md:text-lg text-oth-ink2 leading-relaxed max-w-[640px]">{it.a}</p>
                                        </motion.div>
                                    </motion.button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
